<script setup lang="ts">
import DateField from '@/components/forms/DateField.vue';
import { useDisplay } from 'vuetify';

const text = defineModel();

const props = withDefaults(
    defineProps<{
        label: string;
        type?: 'text' | 'password' | 'date';
        isReadonly?: boolean;
        includeTime?: boolean;
        min?: string;
        max?: string;
        rules?: ((value: any) => string | boolean)[];
        required?: boolean;
    }>(),
    {
        type: 'text',
        required: false,
        rules: () => []
    }
);

const { smAndDown } = useDisplay();
</script>

<template>
    <v-row class="justify-sm-space-between my-0 align-center">
        <v-col cols="5">
            <label :for="props.label">{{ props.label }}</label>
        </v-col>
        <v-col md="4" cols="7">
            <p v-if="isReadonly">{{ text }}</p>
            <template v-else>
                <DateField
                    v-if="props.type === 'date'"
                    v-model="text"
                    :label="props.label"
                    :include-time
                    :min="min"
                    :max="max"
                    :rules="rules"
                    :required="required"
                    :id="props.label"
                />
                <v-text-field
                    v-else
                    :type="props.type"
                    v-model="text"
                    :label="props.label"
                    :rules="rules"
                    :required="required"
                    :id="props.label"
                    :hide-details="smAndDown ? 'auto' : false"
                    :class="smAndDown && 'ga-3'"
                />
            </template>
        </v-col>
    </v-row>
</template>

<style scoped>
label {
    font-weight: bold;
    font-size: 18px;
}
</style>
